module.exports = __webpack_public_path__ + "static/member03-17ecb6897d5cf0c32ce72bfe854726af.png";